import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=5d1c58c2&"
import script from "./Chapter.vue?vue&type=script&lang=ts&"
export * from "./Chapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports